import React from "react";

const Tag = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M32.857 2H20.286c-.303 0-.594.12-.808.335L2.335 19.477a1.143 1.143 0 000 1.616v.001l12.571 12.571c.447.447 1.17.447 1.616 0l17.143-17.142c.214-.215.335-.506.334-.81V3.144C34 2.512 33.488 2 32.857 2zM26 12.285a2.286 2.286 0 110-4.571 2.286 2.286 0 010 4.571z"
            fill={fill}
        />
    </svg>
);

export default Tag;
